export default "__VITE_ASSET__fcDyat2i__"